// extracted by mini-css-extract-plugin
export default {"mealPlanContainer":"style_mealPlanContainer__QhytT","mealPlan":"style_mealPlan__UD5v3","card":"style_card__j4iwW","cardImage":"style_cardImage__fBd7C"};